export const errorSelector = (state) => state.admin.error;
export const isLoadingSelector = (state) => state.admin.isLoading;
